//APP

export const ERROR = 'ERROR';
export const OVERRIDE = 'OVERRIDE';
export const APP_USE_FULLSCREEN = 'APP_USE_FULLSCREEN'; // TODO: new properly name

//DEVICE
export const DEVICE = 'DEVICE';

//USER
export const USER = 'USER';
export const USER_SESSION = 'USER_SESSION';
export const SET_USER_FAVORITES = 'SET_USER_FAVORITES';

//VIEW

//VIDEO_INFO

export const VIDEO_ID = 'VIDEO_ID';

//ELEMENT
export const CREATE_ELEMENT = 'CREATE_ELEMENT';
export const ELEMENT_CREATED = 'ELEMENT_CREATED';
export const DELETE_ELEMENT = 'DELETE_ELEMENT';
export const ELEMENT_DELETED = 'ELEMENT_DELETED';
export const ELEMENT_ACTION = 'ELEMENT_ACTION';

//MQTT
export const MNS_CONNECTION_STATE_CHANGE = 'MQTT_CONNECTION_CHANGE';
